import { render, staticRenderFns } from "./RecentChats.vue?vue&type=template&id=00346bf3&scoped=true"
import script from "./RecentChats.vue?vue&type=script&lang=js"
export * from "./RecentChats.vue?vue&type=script&lang=js"
import style0 from "./RecentChats.vue?vue&type=style&index=0&id=00346bf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00346bf3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
